export default "./dist/stdassets/images/icons/about.png";